import React from 'react';

const FivthFirst = ({ data, onClick }) => {
  return (
    <div onClick={onClick} className='flex w-full text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>
      <div className='flex flex-col w-[12.5%] border border-black'>
        <div className='bg-blue-200 h-full flex justify-center items-center text-center'>소각로</div>
      </div>
      <div className='flex flex-col w-[12.65%] border border-black'>
        <div className='h-[40px] sm:h-[60px] md:h-[80px] bg-blue-200 flex justify-center items-center text-center border-b-2  border-black'>
          구분
        </div>
        <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'>
          1소각
        </div>
        <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'>2소각</div>
      </div>
      <div className='flex flex-col w-[25.05%] border border-black'>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
          생산량/톤(일)
        </div>
        <div className='flex'>
          <div className='flex flex-col w-[50%] border-r border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              목표
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[50%] border-l border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-[25.05%] border border-black'>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2  border-black'>
          생산량 누계/톤(월)
        </div>
        <div className='flex'>
          <div className='flex flex-col w-[50%] border-r border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              목표
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[50%] border-l border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-[37.53%] border border-black'>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2  border-black'>
          가동율 (%)
        </div>
        <div className='flex '>
          <div className='flex flex-col w-[33.3%]'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              월목표
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.3%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적(일)
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.4%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적누계
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FivthFirst;
